var $68c6a7b0ecf7883e$exports = {};
"use strict";
[
    ...document.getElementsByTagName("details")
].forEach((D, _, A)=>D.addEventListener("toggle", (E)=>D.open && A.forEach((d)=>d != E.target && (d.open = false))));


//# sourceMappingURL=booking-link.d6972b24.js.map
